import React, { useEffect, useState } from "react";
import "../BEdit.scss";
import "./businessConnectEditPage.scss";
import * as images from "../../../../images";
import "swiper/css";
import "swiper/css/pagination";
import config from "../../../../config/config";
import helper from "../../../../helpers/helper";
import { infoIconEditProfile } from "../../../../images";
import FormFiveModal from "../../../../components/FormFiveModal/FormFiveModal";
import WorkPlaceDefaultPopup from "../PopUpComponents/WorkplaceEditPopups/WorkPlaceDefaultPopup";
import useTheme from "../../../../components/useTheme/useTheme";

const SocialLink = ({ icon, link, type }) => (
  <div className="social_liks_connect">
    <img src={icon} alt={type} className="social-icons_connect" />
    <a href={link} target="_blank" rel="noreferrer" className="social_link">
      {helper.formatSocialLink(type, link)}
    </a>
  </div>
);

const datainfoBedit = (
  <li className="list_item">
    These links form a permanent part of your business intelligence used for AI
    matchmaking. To replace or delete them, please contact us at{" "}
    <a href="mailto:help@archinza.com" className="text-decoration-underline">
      help@archinza.com
    </a>
  </li>
);

const BusinessConnectView = ({ data }) => {
  const { theme } = useTheme();
  const [isLoading, setIsLoading] = useState(true);
  const aws_object_url = config.aws_object_url;
  const [modalShow, setModalShow] = useState(false);
  const [isGalleryPopupConnect, setIsGalleryPopupConnect] = useState(false);
  const handleShowGalleryPopupConnect = () => setIsGalleryPopupConnect(true);
  const handleHideGalleryPopupConnect = () => setIsGalleryPopupConnect(false);
  useEffect(() => {
    if (data) setIsLoading(false);
  }, [data]);

  const hasLocation =
    data?.google_location?.latitude &&
    data?.google_location?.longitude &&
    data?.google_location?.latitude !== "NA" &&
    data?.google_location?.longitude !== "NA";

  const hasWorkspaceMedia = data?.workspace_media?.length > 0;

  const showContactInfo = hasLocation || hasWorkspaceMedia;

  const hasSocialLinks =
    data?.website_link || data?.linkedin_link || data?.instagram_handle;

  const renderBusinessHours = () => {
    if (!Array.isArray(data?.business_hours)) return null;

    return data.business_hours.map((item, index) => (
      <div key={index} className="business_working_hr">
        <div className="day_working">{item.day}</div>
        <div className="time_working">
          {item.isClosed ? "Closed" : `${item.open} - ${item.close}`}
        </div>
      </div>
    ));
  };

  if (!data) return null;

  return (
    <>
      <WorkPlaceDefaultPopup
        show={isGalleryPopupConnect}
        onHide={() => setIsGalleryPopupConnect(false)}
        handleClose={handleHideGalleryPopupConnect}
        data={data?.workspace_media}
        recentlyDeletedData={data?.recently_deleted}
        isEditable={data.isEditable}
        theme={theme}
      />
      <main className="bedit_main">
        <section className="bEdit_grid_wrapper">
          <div className="my_container">
            <div className="row">
              <div className="col-lg-7 right_section_col_bEdit Contact_Info_col_main_warapper">
                <div className="my_container">
                  {/* Contact Info */}
                  {showContactInfo && (
                    <div className="Contact_Info_wrapper">
                      <div className="heading_common_contact_info">
                        Contact Info
                      </div>

                      <div className="map_gallery_wrapper">
                        {hasWorkspaceMedia && (
                          <div className="gallery_Workplace">
                            <img
                              src={`${aws_object_url}business/${data.workspace_media[0].url}`}
                              alt="workplace"
                              className="work_place_default_image"
                            />
                            <img
                              src={images.groupImageIcon}
                              alt="gallery"
                              className="group_Image_Icon"
                              onClick={handleShowGalleryPopupConnect}
                            />
                          </div>
                        )}

                        {hasLocation && !isLoading && (
                          <div className="connect_map">
                            <iframe
                              title="google-map"
                              src={`https://www.google.com/maps?q=${data.google_location.latitude},${data.google_location.longitude}&output=embed`}
                              width="100%"
                              height="100%"
                              style={{ border: 0 }}
                              loading="lazy"
                              className="map_frame_connect"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Social Links */}
                  {hasSocialLinks && (
                    <div className="Contact_Info_wrapper nw_social_links_wrapper">
                      <div className="heading_common_contact_info">
                        Social Links
                        <img
                          src={infoIconEditProfile}
                          alt="info"
                          className="inf_icon_prf"
                          onClick={() => setModalShow(true)}
                        />
                      </div>

                      {data?.website_link && (
                        <SocialLink
                          icon={images.webIcon}
                          link={data.website_link}
                          type="website"
                        />
                      )}

                      {data?.linkedin_link && (
                        <SocialLink
                          icon={images.linkedInIcon}
                          link={data.linkedin_link}
                          type="linkedin"
                        />
                      )}

                      {data?.instagram_handle && (
                        <SocialLink
                          icon={images.instaIcon}
                          link={data.instagram_handle}
                          type="instagram"
                        />
                      )}
                    </div>
                  )}

                  {/* Business Working Hours */}
                  {data?.business_hours?.length > 0 && (
                    <div className="Contact_Info_wrapper nw_Business_Working_hr_wrap">
                      <div className="heading_common_contact_info">
                        Business Working Hours
                      </div>

                      {renderBusinessHours()}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <FormFiveModal
        list={datainfoBedit}
        show={modalShow}
        onHide={() => setModalShow(false)}
         infoIconLightTheme={theme === "light"}
        className={`${
          theme === "dark"
            ? "modal_info--dark-mode-act-bs"
            : "company-profile-modal-pdf-info"
        } `}
        backdropClassName={`${
          theme === "dark"
            ? "company-profile-pdf-info-backdrop--dark-mode-act-bs"
            : "company-profile-pdf-info-backdrop"
        }`}
      />
    </>
  );
};

export default BusinessConnectView;
